import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=8ef55fc6&scoped=true"
import script from "./PersonList.vue?vue&type=script&lang=js"
export * from "./PersonList.vue?vue&type=script&lang=js"
import style0 from "./PersonList.vue?vue&type=style&index=0&id=8ef55fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef55fc6",
  null
  
)

export default component.exports